var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 64,
    viewBox: "0 0 109 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3344 18.373H95.5872C94.1946 14.0799 90.4549 11 86.0466 11C81.6379 11 77.8982 14.0799 76.5061 18.373H75.6656C72.5364 18.373 70 21.121 70 24.5119V26H101V24.5119C101 21.121 98.4631 18.373 95.3344 18.373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3344 18.373H95.5872C94.1946 14.0799 90.4549 11 86.0466 11C81.6379 11 77.8982 14.0799 76.5061 18.373H75.6656C72.5364 18.373 70 21.121 70 24.5119V26H101V24.5119C101 21.121 98.4631 18.373 95.3344 18.373Z",
    fill: "#DCE6EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3349 26.373H25.5872C24.1946 22.0804 20.4549 19 16.0471 19C11.6379 19 7.89818 22.0804 6.50657 26.373H5.66556C2.53642 26.373 0 29.1215 0 32.5119V34H31V32.5119C31 29.1215 28.4631 26.373 25.3349 26.373Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3349 26.373H25.5872C24.1946 22.0804 20.4549 19 16.0471 19C11.6379 19 7.89818 22.0804 6.50657 26.373H5.66556C2.53642 26.373 0 29.1215 0 32.5119V34H31V32.5119C31 29.1215 28.4631 26.373 25.3349 26.373Z",
    fill: "#DCE6EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.334 56.373H103.587C102.195 52.0804 98.4549 49 94.0466 49C89.6379 49 85.8982 52.0804 84.5061 56.373H83.6656C80.5364 56.373 78 59.1215 78 62.5124V64H109V62.5124C109 59.1215 106.463 56.373 103.334 56.373Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.334 56.373H103.587C102.195 52.0804 98.4549 49 94.0466 49C89.6379 49 85.8982 52.0804 84.5061 56.373H83.6656C80.5364 56.373 78 59.1215 78 62.5124V64H109V62.5124C109 59.1215 106.463 56.373 103.334 56.373Z",
    fill: "#F3F4F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59V61H72",
    stroke: "#1A55B5",
    strokeWidth: 2.423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69 60.9999H20",
    stroke: "#1A55B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.69 7.69"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 61H16V59",
    stroke: "#1A55B5",
    strokeWidth: 2.423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 55.0597V8.50039C16 7.11968 17.046 6 18.3353 6H72.6642C73.954 6 75 7.11968 75 8.50039V57",
    stroke: "#1A55B5",
    strokeWidth: 2.423,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 54H23V2.45951C23 1.10109 24.0809 0 25.4145 0H81.5855C82.9191 0 84 1.10109 84 2.45951V54Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 54H23V2.45951C23 1.10109 24.0809 0 25.4145 0H81.5855C82.9191 0 84 1.10109 84 2.45951V54Z",
    fill: "#F3F4F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 10H23V2.34744C23 1.05118 24.0809 0 25.4145 0H81.5855C82.9191 0 84 1.05118 84 2.34744V10Z",
    fill: "#527EE9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0007 50C54.936 44.5417 59.3604 40.0641 64.8832 40.0007C70.4056 39.9368 74.9358 44.3098 75 49.768L55.0007 50Z",
    fill: "#303A4F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52 32H62",
    stroke: "#2A3247",
    strokeWidth: 2.704,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 33C57.0137 35.2113 58.5749 37 60.4997 37C62.4246 37 63.9858 35.2113 64 33H57Z",
    fill: "#2A3247"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32H76",
    stroke: "#2A3247",
    strokeWidth: 2.704,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 33C70.0137 35.2113 71.5749 37 73.4997 37C75.4246 37 76.9858 35.2113 77 33H70Z",
    fill: "#2A3247"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 41.5C52 43.4326 49.5374 45 46.4998 45C43.4626 45 41 43.4326 41 41.5C41 39.5669 43.4626 38 46.4998 38C49.5374 38 52 39.5669 52 41.5Z",
    fill: "#FE9280"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 38.014C84.8277 38.0063 84.6549 38 84.4785 38C80.9008 38 78 39.5665 78 41.4998C78 43.433 80.9008 45 84.4785 45C84.6549 45 84.8277 44.9932 85 44.986V38.014Z",
    fill: "#FE9280"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.49953C32 5.88071 30.8807 7 29.4995 7C28.1193 7 27 5.88071 27 4.49953C27 3.11929 28.1193 2 29.4995 2C30.8807 2 32 3.11929 32 4.49953Z",
    fill: "#FFC957"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 4.49953C38 5.88071 36.8807 7 35.4995 7C34.1193 7 33 5.88071 33 4.49953C33 3.11929 34.1193 2 35.4995 2C36.8807 2 38 3.11929 38 4.49953Z",
    fill: "#F3F4F6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 4.49953C46 5.88071 44.8807 7 43.4995 7C42.1193 7 41 5.88071 41 4.49953C41 3.11929 42.1193 2 43.4995 2C44.8807 2 46 3.11929 46 4.49953Z",
    fill: "#6AA5FE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0677 56.9998C67.4292 57.0172 66.0862 55.8085 66.0669 54.2996L66 49.0638L71.9329 49L71.9998 54.2362C72.0187 55.7447 70.7062 56.982 69.0677 56.9998Z",
    fill: "#FF746F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWindow);
export default __webpack_public_path__ + "static/media/error_window.2d8b03b4f62239971f4b7c3b5a983c1c.svg";
export { ForwardRef as ReactComponent };